import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import styles from './PerfilCliente.module.css';
import FooterOpcoes from '../components/FooterOpcoes';
import { FaUser, FaCamera, FaShoppingBag, FaQuestionCircle, FaChevronRight } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";

function PerfilCliente() {
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mensagem, setMensagem] = useState({ tipo: "", texto: "" });

  const API_URL = process.env.REACT_APP_API_URL;
  const id_cliente = localStorage.getItem("id_cliente");

  useEffect(() => {
    const fetchCliente = async () => {
      if (!id_cliente) {
        navigate("/home");
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const response = await fetch(`${API_URL}/buscaclientes/${id_cliente}`, { headers });

        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            localStorage.clear();
            navigate("/home");
            return;
          }
          throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();
        setCliente(data);
      } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        if (error.message?.includes('401') || error.message?.includes('403')) {
          localStorage.clear();
          navigate("/home");
          return;
        }
        setMensagem({ tipo: "erro", texto: "Erro ao carregar perfil do cliente" });
      } finally {
        setLoading(false);
      }
    };

    fetchCliente();
  }, [id_cliente, API_URL, navigate]);

  const handleUpload = async () => {
    if (!selectedFile) {
      setMensagem({ tipo: "erro", texto: "Selecione uma imagem primeiro" });
      return;
    }
    if (!selectedFile.type.startsWith('image/')) {
      setMensagem({ tipo: "erro", texto: "Por favor, selecione uma imagem válida" });
      return;
    }
    if (selectedFile.size > 5 * 1024 * 1024) {
      setMensagem({ tipo: "erro", texto: "A imagem deve ter no máximo 5MB" });
      return;
    }

    const formData = new FormData();
    formData.append("imagem", selectedFile);

    try {
      const token = localStorage.getItem('token');
      const headers = {};
      if (token) headers['Authorization'] = `Bearer ${token}`;

      const res = await fetch(`${API_URL}/clientes/upload/${cliente.id_cliente}`, {
        method: "POST",
        headers,
        body: formData
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setCliente(prev => ({ ...prev, imagem_perfil: data.imagem_perfil }));
        setSelectedFile(null);
        setMensagem({ tipo: "sucesso", texto: "Imagem enviada com sucesso!" });
        setTimeout(() => setMensagem({ tipo: "", texto: "" }), 3000);
      } else {
        setMensagem({ tipo: "erro", texto: data.message || "Erro ao enviar imagem" });
      }
    } catch (err) {
      console.error("Erro ao enviar imagem:", err);
      setMensagem({ tipo: "erro", texto: "Erro ao conectar com o servidor" });
    }
  };

  const handleFotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleSair = () => {
    localStorage.clear();
    navigate("/home");
  };

  useEffect(() => {
    if (!loading && !cliente) {
      localStorage.clear();
      navigate("/home");
    }
  }, [loading, cliente, navigate]);

  if (loading || !cliente) {
    return (
      <div className={styles.container}>
        <p className={styles.carregando}>Carregando...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>

      {mensagem.texto && (
        <div className={`${styles.mensagem} ${styles[mensagem.tipo]}`}>
          {mensagem.texto}
        </div>
      )}

      {/* Card de perfil */}
      <section className={styles.cardPerfil}>
        <div className={styles.fotoContainer}>
          <div className={styles.fotoWrapper}>
            {selectedFile ? (
              <img src={URL.createObjectURL(selectedFile)} alt="Preview" className={styles.fotoPerfil} />
            ) : cliente.imagem_perfil ? (
              <img
                src={`${API_URL}/uploads/${cliente.imagem_perfil}`}
                alt="Foto de perfil"
                className={styles.fotoPerfil}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div className={styles.avatarPlaceholder}>
                <FaUser />
              </div>
            )}
            <label htmlFor="inputFoto" className={styles.btnCamera}>
              <FaCamera />
              <input id="inputFoto" type="file" accept="image/*" onChange={handleFotoChange} className={styles.inputFoto} />
            </label>
          </div>
        </div>

        <div className={styles.infoBasica}>
          <h2>{cliente.nome}</h2>
          <p className={styles.emailUsuario}>{cliente.email_institucional}</p>
        </div>
      </section>

      {selectedFile && (
        <div className={styles.uploadActions}>
          <button className={styles.saveBtn} onClick={handleUpload}>Salvar foto</button>
          <button className={styles.cancelBtn} onClick={() => setSelectedFile(null)}>Cancelar</button>
        </div>
      )}

      {/* Menu de opções */}
      <section className={styles.menuOpcoes}>
        <div className={styles.itemMenu} onClick={() => navigate("/pedidoscliente")}>
          <div className={styles.itemIcone}>
            <FaShoppingBag />
          </div>
          <span className={styles.itemLabel}>Meus Pedidos</span>
          <FaChevronRight className={styles.itemSeta} />
        </div>

        <div className={styles.itemMenu}>
          <div className={styles.itemIcone}>
            <FaQuestionCircle />
          </div>
          <span className={styles.itemLabel}>Ajuda e Suporte</span>
          <FaChevronRight className={styles.itemSeta} />
        </div>

        <div className={`${styles.itemMenu} ${styles.itemMenuSair}`} onClick={handleSair}>
          <div className={`${styles.itemIcone} ${styles.itemIconeSair}`}>
            <FiLogOut />
          </div>
          <span className={styles.itemLabelSair}>Sair da Conta</span>
        </div>
      </section>

      <FooterOpcoes typeView="cliente" />
    </div>
  );
}

export default PerfilCliente;
